"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_redux_1 = require("react-redux");
const luxon_1 = require("luxon");
const mui_1 = require("tss-react/mui");
const material_1 = require("@mui/material");
const Divider_1 = __importDefault(require("@mui/material/Divider"));
const react_use_1 = require("react-use");
const core_1 = require("components/QCurrency/core");
const selectors_1 = require("data/transactions/selectors");
const TransactionLabel_1 = __importDefault(require("../TransactionLabel"));
const styles_1 = require("../../styles");
const useStyles = (0, mui_1.makeStyles)()(styles_1.calDayStyles);
const maxTxnsDefault = 3;
const hoverDelay = 500;
const CalDay = (props) => {
    const { classes, cx } = useStyles();
    const dayRef = (0, react_1.useRef)();
    const { day, currentMonth, currentDay, txnList, setPopper, date, balances, onTxnsModalOpen } = props;
    const filteredTxnList = (0, react_redux_1.useSelector)((state) => (0, selectors_1.filterCalendarTxnBasedOnPreferences)(state, { txnList }));
    const [isReady, cancelTimeout, resetTimeout] = (0, react_use_1.useTimeout)(hoverDelay);
    const [hoveringContent, setHoveringContent] = (0, react_1.useState)('');
    const showDailyBalances = Boolean(balances);
    const maxTxns = showDailyBalances ? maxTxnsDefault - 1 : maxTxnsDefault;
    const showMoreLabel = (0, react_1.useMemo)(() => (filteredTxnList === null || filteredTxnList === void 0 ? void 0 : filteredTxnList.size) > maxTxns, [filteredTxnList, maxTxns]);
    const isReadyFlag = isReady();
    const { positiveBalance, negativeBalance } = classes;
    const getBalanceClass = (0, react_1.useCallback)((amount) => (amount >= 0.0 ? positiveBalance : negativeBalance), [positiveBalance, negativeBalance]);
    const onMouseEnter = (0, react_1.useCallback)(() => {
        setHoveringContent('full');
    }, [setHoveringContent]);
    const onMouseLeaveParent = (0, react_1.useCallback)(() => {
        if (hoveringContent) {
            setHoveringContent('');
        }
    }, [hoveringContent, setHoveringContent]);
    const txnsTotal = (0, react_1.useMemo)(() => filteredTxnList && filteredTxnList.reduce((acc, txn) => { var _a; return acc + parseFloat((_a = txn.amount) !== null && _a !== void 0 ? _a : 0); }, 0), [filteredTxnList]);
    const cachedOnTxnsModalOpen = (0, react_1.useCallback)(() => onTxnsModalOpen &&
        onTxnsModalOpen(date, filteredTxnList, (0, core_1.formatAmount)(txnsTotal)), [onTxnsModalOpen, date, txnsTotal, filteredTxnList]);
    const smallTxnList = (0, react_1.useMemo)(() => showMoreLabel ?
        filteredTxnList.slice(0, maxTxns) :
        filteredTxnList, [showMoreLabel, filteredTxnList, maxTxns]);
    const dailyBalancesClassNames = cx(classes.dailyBalanceLabel, { [classes.dailyBalanceLabelFloating]: showMoreLabel }, { [classes.negativeBalance]: Math.sign(balances === null || balances === void 0 ? void 0 : balances.total) < 0 });
    const renderedSmallTxnList = (0, react_1.useMemo)(() => smallTxnList &&
        smallTxnList.map((txn) => <TransactionLabel_1.default key={txn.id} txn={txn}/>), [smallTxnList]);
    const renderedFilteredTxnList = (0, react_1.useMemo)(() => filteredTxnList && filteredTxnList.map((txn) => <TransactionLabel_1.default key={txn.id} txn={txn}/>), [filteredTxnList]);
    const renderedBalanceList = (0, react_1.useMemo)(() => balances && [...balances.accountsBalances.keys()].map((key) => {
        const { balance } = balances.accountsBalances.get(key);
        const balanceClass = getBalanceClass(balance);
        return (<div key={key} className={classes.balanceLabelRoot}>
        <span className={classes.balanceAccountLabel}>{balances.accountsBalances.get(key).name}</span>
        <span className={cx(balanceClass, classes.balanceAmountLabel)}>{(0, core_1.formatAmount)(balance)}</span>
      </div>);
    }), [balances, getBalanceClass, classes, cx]);
    const renderBalancePopper = (0, react_1.useCallback)(() => {
        const totalClass = getBalanceClass(balances === null || balances === void 0 ? void 0 : balances.total);
        return (<>
        <div className={classes.popperTxnList}>
          {renderedBalanceList && renderedBalanceList}
        </div>
        <Divider_1.default className={classes.balanceDivider}/>
        <div className={classes.balanceLabelRoot}>
          <strong>Balance</strong>
          <strong className={totalClass}>{(0, core_1.formatAmount)(balances === null || balances === void 0 ? void 0 : balances.total)}</strong>
        </div>
      </>);
    }, [balances, classes, getBalanceClass, renderedBalanceList]);
    const renderTxnPopper = (0, react_1.useCallback)(() => (filteredTxnList.size > 0 ? (<>
        <div className={classes.popperTxnList}>
          {renderedFilteredTxnList}
        </div>
        <Divider_1.default className={classes.balanceDivider}/>
        <div className={classes.balanceLabelRoot}>
          <strong>Total</strong>
          <strong>{(0, core_1.formatAmount)(txnsTotal)}</strong>
        </div>
      </>) : <div className={classes.popperTxnEmptyList}>No transactions</div>), [classes, filteredTxnList, txnsTotal, renderedFilteredTxnList]);
    const popoverContents = (0, react_1.useCallback)(() => ({
        header: <header className={classes.popperHeader}>{date.toLocaleString(luxon_1.DateTime.DATE_HUGE)}</header>,
        transactions: renderTxnPopper(),
        balance: renderBalancePopper(),
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }), [classes, date, renderTxnPopper, renderBalancePopper, filteredTxnList]);
    (0, react_1.useEffect)(() => {
        const isHovering = Boolean(hoveringContent);
        if (!isHovering) {
            cancelTimeout();
        }
        if (isHovering && isReady() === null) {
            resetTimeout();
        }
        if (isHovering) {
            if (isReady() && hoveringContent === 'full') {
                setPopper(dayRef.current, { hoveringContent, content: popoverContents() });
            }
        }
    }, [isReadyFlag, isReady, hoveringContent, cancelTimeout, resetTimeout, popoverContents, setPopper]);
    return (<material_1.Grid component="div" ref={dayRef} className={cx(classes.day, { [classes.notCurrentMonth]: !currentMonth })} onClick={cachedOnTxnsModalOpen} onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeaveParent}>
      <header className={classes.header}>
        <span className={cx(classes.dayIndicator, { [classes.currentDay]: currentDay })}>{day}</span>
      </header>
      {smallTxnList && (<div className={classes.txnWrapper}>
          {renderedSmallTxnList && renderedSmallTxnList}
          {showMoreLabel && (<TransactionLabel_1.default key="more-label" showMoreLabel={showMoreLabel} extraTxns={filteredTxnList.size - maxTxnsDefault}/>)}
          {showDailyBalances && (<div id={`balance-label-${date.toISODate()}`} data-hover="balance-label" className={dailyBalancesClassNames}>{(0, core_1.formatAmount)(balances.total)}
            </div>)}
        </div>)}
    </material_1.Grid>);
};
exports.default = react_1.default.memo(CalDay);
